<dojo-text-input
  [formCtrl]="formCtrl"
  [placeholder]="placeholder"
  [compact]="compact"
  [label]="label"
  [type]="'text'"
  [hasInitialFocus]="hasInitialFocus"
  [fullWidthField]="fullWidthField"
  id="searchInput"
>
  <ng-container y42InputPrefix>
    <dojo-icon [icon]="icon" [iconClass]="'text-primary'" />
  </ng-container>
  <ng-container dojoInputSuffix *ngIf="formCtrl.value.length > 0">
    <button mat-icon-button (click)="formCtrl.reset('')">
      <dojo-icon [icon]="'times'" [size]="16" [iconClass]="'text-primary'" />
    </button>
  </ng-container>
</dojo-text-input>
